module.exports = __webpack_public_path__ + "static/img/android-chrome-512x512.8635ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-chrome-512x512.png
// module id = GmWZ
// module chunks = 1